// extracted by mini-css-extract-plugin
export var ColLeft = "blog-post-module--ColLeft--af087";
export var ColRight = "blog-post-module--ColRight--c6953";
export var Container = "blog-post-module--Container--774d0";
export var Content = "blog-post-module--Content--021ee";
export var MostRecentPosts = "blog-post-module--MostRecentPosts--12d72";
export var social = "blog-post-module--social--1e93c";